var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfidence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4584_7594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1423 4.71477L7.1423 9.85762M7.1423 4.71477L8.28516 3.57191V1.28619L7.1423 2.42905L5.99944 1.28619V3.57191L7.1423 4.71477ZM7.1423 9.85762L8.28516 8.71476M7.1423 9.85762L5.99944 8.71476",
    stroke: "currentColor",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14453 9.2864C1.14453 10.8643 3.83082 12.1435 7.14453 12.1435C10.4582 12.1435 13.1445 10.8643 13.1445 9.2864C13.1445 7.70846 10.4582 6.42926 7.14453 6.42926C3.83082 6.42926 1.14453 7.70846 1.14453 9.2864Z",
    stroke: "currentColor",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4584_7594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "matrix(0 1 -1 0 14 0.142853)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidence);
export default __webpack_public_path__ + "static/media/confidence.945eb8372219b3934e45bf62610363d9.svg";
export { ForwardRef as ReactComponent };